export function createFindFileWorker() {
  return new Worker(new URL('./find-file.worker.ts', import.meta.url), {type: 'module'})
}
